<template>
  <div class="page">
    <div>
      <!-- 左侧侧边栏 -->
      <sidebarUserInfo></sidebarUserInfo>
    </div>
    <div>
      <btnTopBar
        :topList="topList"
        :moren="moren"
        v-if="topList.length > 0"
      ></btnTopBar>
      <div class="thetopbox">
        <el-form ref="form" :model="queryParams" label-width="200px">
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('N_I_124')" prop="memberCode"
                ><el-input clearable v-model="queryParams.memberCode"></el-input
              ></el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('N_I_242')" prop="memberSettlePeriodId">
                <el-select
                  clearable
                  :placeholder="$t('CK_KS_38')"
                  v-model="queryParams.memberSettlePeriodId"
                >
                  <el-option
                    v-for="item in memberSettlePeriodList"
                    :key="item.pkId"
                    :label="item.settleDate"
                    :value="item.pkId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('w_0166')" prop="level"
                ><el-input clearable v-model="queryParams.level"></el-input
              ></el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('w_0167')" prop="cantz">
                <el-select
                  clearable
                  :placeholder="$t('CK_KS_38')"
                  v-model="cantz"
                >
                  <el-option
                    v-for="(item, index) in tzList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="margin-left: 30px">
              <div class="searchbox">
                <el-button class="searchbtn" @click="getSearch">{{
                  $t("N_I_183")
                }}</el-button>
                <el-button @click="reChongzhi">{{ $t("CK_KS_6") }}</el-button>
                <el-button @click="goback">{{ $t("N_I_241") }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="theorgtree">
        <div class="lefttop">
          <div
            class="single"
            v-for="(item, index) in avaerInfoList"
            :key="index"
          >
            <img :src="item.value" alt="" />
            <div class="singletitle">{{ item.name }}</div>
          </div>
        </div>
        <div class="tree">
          <div class="tree-content" @mousedown.stop="move" @wheel="handleWheel">
            <div :style="{ transform: `scale(${scale})` }">
              <vue2-org-tree
                :data="data"
                collapsable
                ref="orgTree"
                @on-expand="onExpand"
                @on-node-click="NodeClick"
                @on-node-mouseover="onMouseover"
                @on-node-mouseout="onMouseout"
                :renderContent="renderContent"
                v-bind="$listeners"
              />
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        :visible.sync="ifShow"
        :close-on-click-modal="false"
        width="700px"
      >
        <div class="rendercontent">
          <div ref="htmlContent">
            <div class="toprender">
              <div class="leftimg">
                <img
                  class="img1"
                  :src="'data:image/png;base64,' + treeData.avatarUrlBase64"
                />
                <img
                  class="img2"
                  :src="'data:image/png;base64,' + treeData.countryUrl2Base64"
                />
              </div>
              <div class="centerbox">
                <div class="lineboex">
                  <div class="linetitle">{{ $t("N_I_124") }}</div>
                  <div class="linecontent">{{ treeData.memberCode }}</div>
                </div>
                <div class="lineboex">
                  <div class="linetitle">{{ $t("CK_KS_14") }}</div>
                  <div class="linecontent">{{ treeData.name }}</div>
                </div>
                <div class="lineboex">
                  <div class="linetitle">{{ $t("MY_ORD_3") }}</div>
                  <div class="linecontent">{{ treeData.payDate }}</div>
                </div>
              </div>
              <div class="rightimg">
                <img
                  :src="
                    'data:image/png;base64,' + treeData.settleCountryUrl2Base64
                  "
                />
                <div>{{ $t("PER_DA_4") }}</div>
              </div>
            </div>
            <div class="bottomrender">
              <div class="flexbox">
                <div class="thetitle">{{ $t("ENU_TOTAL_V_1") }}(PV)</div>
                <div class="linecontent">{{ $t("ENU_MENU_102") }}</div>
                <div class="linecontent">{{ $t("N_I_103") }}</div>
                <div class="linecontent">{{ $t("fn_089") }}</div>
              </div>
              <div class="depment-data-wrap">
                <template v-for="(v, idx) in treeData.levelMemberSettleList">
                  <div>
                    <div class="thetitle" v-if="(v.placeDept || idx + 1) >= 4">
                      {{ v.placeDept || idx + 1
                      }}<span v-if="languages === 'en-US'">th</span>
                      {{ $t("fn_011") }}
                    </div>
                    <div class="thetitle" v-else>
                      {{ v.placeDept || idx + 1 }}{{ $t("fn_011") }}
                    </div>
                    <!-- <div class="thetitle">{{ $t('fn_010') }}{{ v.placeDept || idx + 1 }}{{ $t('fn_011') }}</div> -->
                    <div class="linecontent">
                      {{ v.newPv | numberToCurrency }}
                    </div>
                    <div class="linecontent">
                      {{ v.sumPv | numberToCurrency }}
                    </div>
                    <div class="linecontent">
                      {{ v.abalance | numberToCurrency }}
                      <span>/</span>
                      {{ v.bbalance | numberToCurrency }}
                    </div>
                  </div>
                </template>
              </div>
              <!-- <div class="flexbox">
                <div class="thetitle">{{$t('S_C_18')}}</div>
                <div class="linecontent">{{ treeData.newPv }}</div>
                <div class="linecontent">
                  {{ treeData.leftFirstPurchaseAdd }}
                </div>
                <div class="linecontent">
                  {{ treeData.leftRepeatPurchaseAdd }}
                </div>
                <div class="linecontent">{{ treeData.leftRealTotal }}</div>
                <div class="linecontent">{{ treeData.sumPv }}</div>
                <div class="linecontent">
                  {{ treeData.leftRepeatPurchaseTotal }}
                </div>
                <div class="linecontent">{{ treeData.abalance }}</div>
                <div class="linecontent">
                  {{ treeData.leftRepeatPurchaseSurplus }}
                </div>
              </div>
              <div class="flexbox">
                <div class="thetitle">{{$t('S_C_19')}}</div>
                <div class="linecontent">{{ treeData.rightRealNewPv }}</div>
                <div class="linecontent">
                  {{ treeData.rightFirstPurchaseAdd }}
                </div>
                <div class="linecontent">
                  {{ treeData.rightRepeatPurchaseAdd }}
                </div>
                <div class="linecontent">{{ treeData.rightRealTotal }}</div>
                <div class="linecontent">{{ treeData.rightFirstTotal }}</div>
                <div class="linecontent">
                  {{ treeData.rightRepeatPurchaseTotal }}
                </div>
                <div class="linecontent">{{ treeData.rightFirstSurplus }}</div>
                <div class="linecontent">
                  {{ treeData.rightRepeatPurchaseSurplus }}
                </div>
              </div> -->
            </div>
          </div>
          <div class="footerbox">
            <div class="footerbtn btn1" @click="downloadImage">
              {{ $t("S_C_45") }}
            </div>
            <div class="footerbtn btn2" @click="copyText">
              {{ $t("N_I_243") }}
            </div>
            <!-- <div class="footerbtn btn3"  @click="goTop(treeData)">置顶</div> -->
          </div>
        </div>
      </el-dialog>
      <div
        class="copyContent"
        ref="copyContent"
        v-show="false"
        style="white-space: pre-wrap"
      >
        <!-- 基础信息 -->
        <div class="common-div">
          {{ $t("N_I_124") }} : {{ treeData.memberCode }}
        </div>
        <br />
        <div class="common-div">{{ $t("CK_KS_14") }}：{{ treeData.name }}</div>
        <div class="common-div">
          {{ $t("MY_ORD_3") }}：{{ treeData.payDate }}
        </div>
        <!-- 数据信息标题 -->
        <div class="copy-title">
          <div>{{ $t("ENU_TOTAL_V_1") }}(PV)</div>
          <div>{{ $t("ENU_MENU_102") }}</div>
          <div>{{ $t("N_I_103") }}</div>
          <div>{{ $t("fn_089") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numberToCurrencyNo } from "@/util/numberToCurrency";
import html2canvas from "html2canvas";
import { mapGetters } from "vuex";
import btnTopBar from "@/components/btnTopBar.vue";
import sidebarUserInfo from "@/components/sidebarUserInfo.vue";
import {
  getAzFramework,
  getAvarerInfo,
  getMemberSettlePeriod,
  getUrlBase,
} from "@/api/archityecture";
export default {
  components: {
    btnTopBar,
    sidebarUserInfo,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  data() {
    return {
      moren: "azjg2",
      topList: [
        {
          name: this.$t("w_0175"),
          path: "azjg1",
        },
        {
          name: this.$t("w_0176"),
          path: "architecture",
        },
        {
          name: this.$t("w_0177"),
          path: "azjg2",
        },
        {
          name: this.$t("w_0178"),
          path: "azjg3",
        },
        {
          name: this.$t("fn_282"),
          path: "azjg4",
        },
      ],
      queryParams: {
        memberSettlePeriodId: "", //期数
        memberCode: "", //会员编号
        level: 3,
        type: 2,
      },
      basicSwitch: false,
      basicInfo: {
        id: null,
        label: null,
      },
      data: {},
      treeData: {},
      ifShow: false,
      avaerInfoList: [],
      memberSettlePeriodList: [], //期数
      tzList: [
        {
          value: 0,
          label: this.$t("EDEALER_YES_NO_0"),
        },
        {
          value: 1,
          label: this.$t("EDEALER_YES_NO_1"),
        },
      ],
      cantz: 1, //0不可拖拽,1可拖拽
      scale: 1,
      languages: "",
    };
  },
  created() {
    this.queryParams.memberCode = this.userInfo.memberCode;

    this.getAvarerInfo();
    this.languages = localStorage.getItem("lang");
  },
  methods: {
    handleWheel(event) {
      if (this.cantz == 1) {
        event.preventDefault();
        const delta = Math.sign(event.deltaY);
        const newScale = this.scale - delta * 0.1;
        this.scale = Math.max(0.01, Math.min(newScale, 10));
      }
    },
    copyText() {
      this.$nextTick(() => {
        const copyContent = this.$refs.copyContent;

        const commonDiv = Array.from(
          copyContent.querySelectorAll(".common-div")
        ).map((div) => div.textContent.trim());

        const copyTitleEle = copyContent.querySelectorAll(".copy-title div");
        const copyTitleList = [];
        copyTitleEle.forEach((v) => {
          if (v.innerText) {
            copyTitleList.push(v.innerText);
          }
        });

        let obj = {
          placeDept: [],
          newPv: [],
          sumPv: [],
          abalance: [],
        };

        this.treeData.levelMemberSettleList.forEach((v, idx) => {
          let placeDept = v.placeDept || idx + 1;
          obj.placeDept.push(
            `${this.$t("fn_010")}${placeDept}${this.$t("fn_011")}`
          );
          obj.newPv.push(numberToCurrencyNo(v.newPv));
          obj.sumPv.push(numberToCurrencyNo(v.sumPv));
          obj.abalance.push(
            numberToCurrencyNo(v.abalance) +
              "/" +
              numberToCurrencyNo(v.bbalance)
          );
        });

        let result = [];
        obj.placeDept.forEach((dept, idx) => {
          let combinedString = `${copyTitleList[0]}${dept}\n${copyTitleList[1]}${obj.newPv[idx]}\n${copyTitleList[2]}${obj.sumPv[idx]}\n${copyTitleList[3]}${obj.abalance[idx]}`;
          result.push(combinedString);
        });

        const copyEle = commonDiv.concat(result);
        const text = copyEle.join("\n");
        const tempInput = document.createElement("textarea");
        tempInput.value = text;
        document.body.appendChild(tempInput);
        tempInput.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: this.$t("MY_CK_29"),
            type: "success",
          });
        } catch (error) {
          this.$message({
            message: this.$t("w_0349"),
            type: "warning",
          });
        }
        tempInput.remove();
        window.getSelection().removeAllRanges();
      });
    },
    // copyText() {
    //   const copyContent = this.$refs.copyContent;

    //   /* const textLines = Array.from(copyContent.querySelectorAll("div")).map(
    //     (div) => div.textContent.trim()
    //   ); */

    //   const commonDiv = Array.from(
    //     copyContent.querySelectorAll(".common-div")
    //   ).map((div) => div.textContent.trim());

    //   const copyTitleEle = copyContent.querySelectorAll(".copy-title div");
    //   const copyTitleList = [];
    //   copyTitleEle.forEach((v) => {
    //     if (v.innerText) {
    //       copyTitleList.push(v.innerText);
    //     }
    //   });

    //   let obj = {
    //     placeDept: [],
    //     newPv: [],
    //     leftFirstPurchaseAdd: [],
    //     leftRepeatPurchaseAdd: [],
    //     leftRealTotal: [],
    //     sumPv: [],
    //     leftRepeatPurchaseTotal: [],
    //     abalance: [],
    //     leftRepeatPurchaseSurplus: [],
    //   };
    //   console.log(this.treeData.levelMemberSettleList);
    //   this.treeData.levelMemberSettleList.forEach((v, idx) => {
    //     for (let key in obj) {
    //       if (key == "placeDept") {
    //         let placeDept = v.placeDept || idx + 1;
    //         obj[key].push(
    //           `${this.$t("fn_010")}${placeDept}${this.$t("fn_011")}`
    //         );
    //       } else if (key == "abalance") {
    //         obj[key].push(
    //           numberToCurrencyNo(v.abalance) +
    //             "/" +
    //             numberToCurrencyNo(v.bbalance)
    //         );
    //       } else {
    //         obj[key].push(numberToCurrencyNo(v[key]));
    //       }
    //     }

    //     if (this.treeData.levelMemberSettleList.length - 1 == idx) {
    //       copyTitleList.forEach((title, titleIdx) => {
    //         if (titleIdx == 0) {
    //           copyTitleList[titleIdx] =
    //             copyTitleList[titleIdx] + obj.placeDept.join("  ");
    //         } else if (titleIdx == 1) {
    //           copyTitleList[titleIdx] =
    //             copyTitleList[titleIdx] + obj.newPv.join("  ");
    //         } else if (titleIdx == 2) {
    //           copyTitleList[titleIdx] =
    //             copyTitleList[titleIdx] + obj.sumPv.join("  ");
    //         } else if (titleIdx == 3) {
    //           copyTitleList[titleIdx] =
    //             copyTitleList[titleIdx] + obj.abalance.join("  ");
    //         }
    //       });
    //     }
    //   });

    //   const copyEle = commonDiv.concat(copyTitleList);

    //   // const text =textLines.join('\n');
    //   const text = copyEle.join("\n");
    //   const tempInput = document.createElement("textarea");
    //   tempInput.value = text;
    //   document.body.appendChild(tempInput);
    //   tempInput.select();
    //   try {
    //     document.execCommand("copy");
    //     this.$message({
    //       message: this.$t("MY_CK_29"),
    //       type: "success",
    //     });
    //   } catch (error) {
    //     this.$message({
    //       message: this.$t("w_0349"),
    //       type: "warning",
    //     });
    //   }
    //   tempInput.remove();
    //   window.getSelection().removeAllRanges();
    // },
    //复制图片
    async downloadImage() {
      const element = this.$refs.htmlContent;
      // 使用html2canvas将节点生成为图片
      const canvas = await html2canvas(element);
      const image = canvas.toDataURL("image/png");
      // 复制图片到剪贴板
      try {
        await navigator.clipboard.write([
          new ClipboardItem({
            "image/png": await new Promise((resolve) =>
              canvas.toBlob(resolve, "image/png")
            ),
          }),
        ]);
        this.$message({
          message: this.$t("MY_CK_29"),
          type: "success",
        });
      } catch (error) {
        // this.$message({
        //   message: this.$t('w_0349'),
        //   type: "warning",
        // });
      }
      // 下载图片到本地
      const link = document.createElement("a");
      link.href = image;
      link.download = "image.png";
      link.click();
    },
    //返回
    goback() {
      this.queryParams.memberCode = this.data.parentMemberCode;
      this.getSearch();
    },
    //拖拽移动
    move(e) {
      if (this.cantz == 0) {
        return;
      }
      const odiv = e.currentTarget; // 获取元素

      // 算出鼠标相对元素的位置
      const disX = e.clientX - odiv.offsetLeft;
      const disY = e.clientY - odiv.offsetTop;
      document.onmousemove = (e) => {
        // 鼠标按下并移动的事件
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        const left = e.clientX - disX;
        const top = e.clientY - disY;

        // 绑定元素位置到positionX和positionY上面
        this.positionX = top;
        this.positionY = left;

        // 移动当前元素
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    exportChart() {
      const element = this.$refs.orgTree.$el; // 获取 vue2-org-tree 的根元素
      html2canvas(element).then((canvas) => {
        const imgData = canvas.toDataURL("image/png"); // 将 canvas 转换成 PNG 图片
        const link = document.createElement("a"); // 创建下载链接
        link.download = "org-tree.png";
        link.href = imgData;
        link.click(); // 下载图片
      });
    },
    getAvarerInfo() {
      getAvarerInfo().then((res) => {
        this.avaerInfoList = res.data;
      });
      getMemberSettlePeriod().then((res) => {
        this.memberSettlePeriodList = res.data;
        this.memberSettlePeriodList.forEach((ele) => {
          if (ele.isThisDay == 0) {
            this.queryParams.memberSettlePeriodId = ele.pkId;
            this.getSearch();
          }
        });
      });
    },
    //鼠标移入
    onMouseover(e, data) {
      this.basicInfo = data;
      this.basicSwitch = true;
    },
    //鼠标移出
    onMouseout(e, data) {
      this.basicSwitch = false;
    },

    //渲染节点
    renderContent(h, data) {
      return (
        <div class="xrBox">
          {" "}
          {/* 判断data.codeName是否为空 */}{" "}
          <div class="neibox">
            {" "}
            {data.memberCode ? (
              <div on-click={() => this.showPover(data)}>
                <div class="topbox">
                  <img src={data.settleCountryUrl2} />{" "}
                </div>{" "}
                <div class="footerbox">
                  {" "}
                  {/* 阻止冒泡事件 */}{" "}
                  <div
                    class="ftopbtn"
                    style={{
                      backgroundColor: data.color,
                    }}
                    on-click={() => {
                      event.stopPropagation(), this.goTop(data);
                    }}
                  >
                    {this.$t("N_I_245")}{" "}
                  </div>{" "}
                </div>{" "}
              </div>
            ) : null}{" "}
          </div>{" "}
        </div>
      );
    },
    //置顶
    goTop(row) {
      this.queryParams.memberCode = row.memberCode;
      this.getSearch();
    },
    showPover(row) {
      getUrlBase({
        countryUrl2: row.countryUrl2,
        settleCountryUrl2: row.settleCountryUrl2,
        avatarUrl: row.avatarUrl,
      }).then((res) => {
        let minShowTotal = 3;
        let levelMemberSettleList = row.levelMemberSettleList;
        let currentLen =
          (row.levelMemberSettleList && row.levelMemberSettleList.length) || 0;
        // if (currentLen < minShowTotal) {
        //   let arr = [];
        //   for (let i = 0; i < minShowTotal - currentLen; i++) {
        //     arr.push({});
        //   }
        //   levelMemberSettleList = levelMemberSettleList.concat(arr);
        // } else {
        //   levelMemberSettleList = row.levelMemberSettleList;
        // }
        levelMemberSettleList = row.levelMemberSettleList;
        this.treeData = row;
        this.treeData.levelMemberSettleList = levelMemberSettleList;
        this.treeData.countryUrl2Base64 = res.countryUrl2Base64;
        this.treeData.settleCountryUrl2Base64 = res.settleCountryUrl2Base64;
        this.treeData.avatarUrlBase64 = res.avatarUrlBase64;

        this.ifShow = true;
      });
    },
    //点击节点
    NodeClick(e, data) {},
    //默认展开
    toggleExpand(data, val) {
      if (Array.isArray(data)) {
        data.forEach((item) => {
          this.$set(item, "expand", val);
          if (item.children) {
            this.toggleExpand(item.children, val);
          }
        });
      } else {
        this.$set(data, "expand", val);
        if (data.children) {
          this.toggleExpand(data.children, val);
        }
      }
    },
    collapse(list) {
      list.forEach((child) => {
        if (child.expand) {
          child.expand = false;
        }
        child.children && this.collapse(child.children);
      });
    },
    //展开
    onExpand(e, data) {
      if ("expand" in data) {
        data.expand = !data.expand;
        if (!data.expand && data.children) {
          this.collapse(data.children);
        }
      } else {
        this.$set(data, "expand", true);
      }
    },
    getSearch() {
      getAzFramework(this.queryParams).then((res) => {
        this.data = res.data[0];
        this.toggleExpand(this.data, true);
      });
    },
    reChongzhi() {
      this.queryParams = {
        memberSettlePeriodId: "", //期数
        memberCode: "", //会员编号
        level: 3,
        type: 2,
      };
      this.getSearch();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .tree-content {
  background: rgba(0, 0, 0, 0) !important;
}

.tree {
  background: #fff;
  // min-height: 100vh;
  min-height: calc(100vh - 110px);
  position: relative;
  text-align: center;
  // overflow-x: scroll;
  width: 100%;
  height: 100%;
  margin: auto;
  overflow: hidden;

  // margin-left: -60px;
  // margin-top: 20px;
  // background: red;
  &-content {
    text-align: center;
    width: 100%;
    height: 100%;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    // overflow: auto;
  }
}

::v-deep .org-tree-node-btn {
  display: none;
}

::v-deep .org-tree-node-label-inner {
  padding: 0;
  // background: #ffffff;
  background: rgba(0, 0, 0, 0);
  padding: 0 !important;
  border: none;
  // box-shadow: 0px 2px 20px 0px rgba(204, 204, 204, 0.5);
  border-radius: 10px;
}

::v-deep .el-dialog__body {
  padding: 0;
}

::v-deep .org-tree-container {
  display: block;
  background: rgba(1, 1, 1, 0) !important;
}

::v-deep .xrBox {
  .neibox {
    padding: 8px 15px;
    margin: auto;
    min-width: 40px;
    min-height: 40px;

    // z-index: 99;
    .topbox {
      margin: 0 auto;

      img {
        width: 52px;
        height: 36px;
        border-radius: 8px;
        // border-radius: 50%;
      }
    }

    .centerbox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      text-align: center;
      box-shadow: 0px 2px 20px 0px rgba(204, 204, 204, 0.5);

      .cflexbox {
        margin: 0 10px;

        img {
          width: 51px;
          height: 34px;
          border-radius: 10px;
          margin-bottom: 8px;
        }

        .matitle {
          font-size: 10px;
        }
      }
    }

    .footerbox {
      // margin-top: 10px;
      .ftopbtn {
        margin: 0 auto;
        // width: 35px;
        // height: 16px;
        background: #21c8f4;
        border-radius: 4px;
        font-size: 4px;
        display: flex;
        padding: 4px 9px;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        cursor: pointer;

        margin-top: 10px;
      }
    }
  }
}

.lefttop {
  display: flex;
  justify-items: center;
  align-items: center;
  padding-left: 20px;
  background: #ffffff;

  .single {
    margin: 0 5px;

    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      // box-shadow: 0px 2px 20px 0px rgba(204, 204, 204, 0.5);
    }

    .singletitle {
      text-align: center;
      font-size: 10px;
      font-family: PingFang SC-Regular, PingFang SC;
    }
  }
}

::v-deep .org-tree-node-label .org-tree-node-label-inner {
  padding: 0;
}

::v-deep .el-dialog__body {
  padding: 0;
}

::v-deep .org-tree-container {
  display: block;
}

// ::v-deep .xrBox {

// }
.theorgtree {
  width: 100%;
  height: 100%;
  // margin: 0 auto;
  // overflow-y: auto;
  // margin-top: 20px;
}

::v-deep .rendercontent {
  .toprender {
    display: flex;
    border-bottom: 1px solid #cccccc;

    .leftimg {
      border-right: 1px solid #cccccc;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px;

      .img1 {
        width: 75px;
        height: 75px;
        border-radius: 50%;
      }

      .img2 {
        margin-top: 10px;
        width: 50px;
        height: 30px;
        border-radius: 10px;
      }
    }

    .centerbox {
      padding: 10px;

      .lineboex {
        display: flex;
        align-items: center;
        margin: 10px 0;

        .linetitle {
          width: 240px;
          margin-right: 5px;
          font-size: 10px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: #333333;
        }
      }
    }

    .rightimg {
      flex: 1;
      padding: 10px;
      font-size: 10px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #333333;
      text-align: center;

      img {
        width: 75px;
        height: 50px;
        border-radius: 10px;
        margin-bottom: 10px;
      }
    }
  }

  .bottomrender {
    padding: 10px;
    display: flex;

    .flexbox {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .footerbox {
    display: flex;
    padding: 10px;
    justify-content: space-around;

    .footerbtn {
      width: 78px;
      // height: 28px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
      padding: 10px;
      cursor: pointer;
    }

    .btn1 {
      background: #ee1e26;
    }

    .btn2 {
      background: #f37825;
    }

    .btn3 {
      background: #21c8f4;
    }
  }
}

::v-deep .org-tree-container {
  display: block;
}

.page {
  padding: 10px 0px;
  background: #f9f9f9;
  font-size: 14px;
  display: flex;

  .thetopbox {
    padding: 20px;
    background: #ffffff;
    border-radius: 8px;

    .searchbox {
      display: flex;
      align-items: center;

      .searchtitle {
        margin-right: 10px;
      }

      .searchbtn {
        background: #c8161d;
        color: #ffffff;
      }
    }
  }
}

::v-deep .org-tree {
  margin: 0 auto;
}

.depment-data-wrap {
  display: flex;
  gap: 5px;
  margin-left: 5px;
  width: 1030px;
  overflow-x: scroll;
}

.linecontent {
  font-size: 10px;
  font-family: MicrosoftYaHei;
  color: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
  width: 166px;
  // height: 20px;
  background: rgba(216, 216, 216, 0.3);
  border-radius: 4px;
  border: 1px solid #cccccc;
  margin-bottom: 5px;
}

.thetitle {
  font-size: 10px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin-bottom: 5px;
}
</style>
